export const IMAGE_POSTER_DEFAULT =
  'https://s3-ap-southeast-1.amazonaws.com/poster.ticketmelon.com/poster-default.png'
export const IMAGE_POSTER_PATH = 'https://s3-ap-southeast-1.amazonaws.com/tm-img-poster-event/'
export const IMAGE_EO_PATH = 'https://s3-ap-southeast-1.amazonaws.com/tm-img-logo-eo/'
export const S3_PUBLIC_PATH = 'https://s3-ap-southeast-1.amazonaws.com/tm-public-file/'
export const TM_WEB_PATH = 'https://www.ticketmelon.com/'
